module.exports = __webpack_public_path__ + "41b440426035c4d3804fa6982d41de83.pdf";